/*
 *
 *  sagas
 *
 */

import { call, take, put, race, select, all, delay } from "redux-saga/effects"

import {
  LOAD_RECORD,
  LOAD_RECORDS,
  CREATE_RECORD,
  UPDATE_RECORD,
  DELETE_RECORD,
  UPDATE_STATUS,
  LOAD_RECORDS_META_DATA,
} from "./constants"

import {
  loadRecords as loadRecordsAction,
  loadRecordsSuccess,
  loadRecordsError,
  loadRecordSuccess,
  loadRecordError,
  createRecordSuccess,
  createRecordError,
  updateRecordSuccess,
  updateRecordError,
  deleteRecordSuccess,
  deleteRecordError,
  updateStatusSuccess,
  updateStatusError,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
} from "./actions"

import {
  loadRecords,
  loadRecord,
  createRecord,
  updateRecord,
  deleteRecord,
  updateStatus,
  loadRecordsMetaData
} from "./remotes"

import { selectRecords } from "./selectors"

//import { selectSession } from "../session/selectors"
//import { roleIds } from "../../helpers/tools"
function* loadRecordsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_RECORDS),
    })

    const { explicitLoad } = load

    if (explicitLoad) {
      try {
        const result = yield call(loadRecords)

        console.log(result, "result")

        if (result) {
          yield put(loadRecordsSuccess(result.data))
          console.log(result.data, "result")
        } else {
          yield put(loadRecordsSuccess([]))
          yield put(loadRecordsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadRecordsSuccess([]))
        yield put(
          loadRecordsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}


function* loadRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const loadRequest = yield race({
      request: take(LOAD_RECORD),
    })
    const { request } = loadRequest

    if (request) {
      const { id } = request

      try {
        const record = yield call(loadRecord, id)
      
        let recordsMetaData = {
         
        }
        if (record) {
          // Delays the dispatch of loadRecordSuccess untill the store is populated with an initial list of records.
          while (true) {
            // eslint-disable-line no-constant-condition
            const recordsInStore = yield select(selectRecords())
            if (recordsInStore && recordsInStore.length > 0) {
              break
            }
            yield delay(500)
          }
          yield put(loadRecordSuccess(record, recordsMetaData))
        } else {
          yield put(loadRecordError("Fetch Record Failed"))
        }
      } catch (error) {
        yield put(
          loadRecordError(
            (error && error.response && error.response.message) ||
              "Fetch Record Failed"
          )
        )
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
     

      const subSource = yield call(
        loadRecordsMetaData,
        "sub_source",
        "post"
      )
 
     let recordsMetaData = {
      subSourceOptions:
      (subSource &&
        subSource.data &&
        subSource.data.length > 0 &&
        subSource.data.map((c) =>
          Object.assign(
            {},
            { label: c.subSourceName, value: c._id, sourceId: c.sourceId }
          )
        )) ||
      [],
     }
     
      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}
function* createRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_RECORD),
    })
    const { record} = create || {}
    if (create) {
     // yield call(setSubmitting, true)
      try {
        yield call(createRecord, record)

        yield delay(1000)
        yield put(createRecordSuccess(record))
        yield put(loadRecordsAction(true))
       
      } catch (error) {
        yield put(
          createRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } 
    }
  }
}

function* editRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_RECORD),
    })
    const { record } = edit || {}
    if (edit) {
      //yield call(setSubmitting, true)

      try {
        yield call(updateRecord, record)
        yield delay(1000)
        yield put(updateRecordSuccess(record, "Record Updated Successfully"))
       // yield call(redirect)
      } catch (error) {
        yield put(
          updateRecordError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      }
    }
  }
}

function* deleteRecordSaga() {
 
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(DELETE_RECORD),
    })
    const {deleteData} = create || {}
    if (create) {
     // yield call(setSubmitting, true)
      try {
        yield call(deleteRecord, deleteData)

        yield delay(1000)
        yield put(deleteRecordSuccess(deleteData))
        yield put((true))
       
      } catch (error) {
        yield put(
          deleteRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } 
    }
  }
}


function* updateStatusSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { update } = yield race({
      update: take(UPDATE_STATUS),
    })
    const { record = {}, setSubmitting, redirect } = update
    yield call(setSubmitting, true)

    try {
      const result = yield call(updateStatus, record)
      if (result) {
        yield put(updateStatusSuccess(record, "Status Updated Successfully"))
        yield call(redirect)
      } else {
        yield put(updateStatusError("Update Status Records Failed"))
      }
    } catch (error) {
      yield put(
        updateStatusError(
          (error && error.response && error.response.message) ||
            "Update Status Records Failed"
        )
      )
    } finally {
      yield call(setSubmitting, false)
    }
  }
}

export default function* recordsSaga() {
  yield all([
    loadRecordSaga(),
    loadRecordsSaga(),
    createRecordSaga(),
    editRecordSaga(),
    deleteRecordSaga(),
    updateStatusSaga(),
    loadRecordsMetaDataSaga()
  ])
}
